import React, { useEffect, useRef } from 'react'
import { ArrowLeft, Sparkles } from 'lucide-react'
import { useAppSelector } from '../../../Redux/Hooks'
import { useNavigate, useParams } from 'react-router-dom'
import CreateNewAlbumPage from '../../molecules/Dashboard/SingleAlbumPage/CreateNewAlbumPage'
import EditAlbumPage from '../../molecules/Dashboard/SingleAlbumPage/EditAlbumPage'
import {
  PageContainer,
  ScrollBody,
  HeroActionsSlot,
} from '../../molecules/Dashboard/SingleAlbumPage/albumFormSharedStyles'
import {
  Hero,
  HeroGlow,
  HeroRow,
  HeroLeft,
  BackButton,
  HeroText,
  HeroBadge,
  PageTitle,
  PageSubtitle,
} from '../../molecules/Dashboard/Member/memberFormStyles'

const SingleAlbum: React.FC = () => {
  const { currentAlbum } = useAppSelector((state) => state.album)
  const navigate = useNavigate()
  const params = useParams()
  const isCreate = params.new === 'true'
  const heroActionsRef = useRef<HTMLDivElement>(null)
  const scrollBodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isCreate && !currentAlbum) {
      navigate('/dashboard/')
    }
  }, [isCreate, currentAlbum, navigate])

  return (
    <PageContainer>
      <Hero
        onWheel={(e) => {
          scrollBodyRef.current?.scrollBy({ top: e.deltaY })
        }}
      >
        <HeroGlow />
        <HeroRow>
          <HeroLeft>
            <BackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
              <ArrowLeft size={18} />
            </BackButton>
            <HeroText>
              <div className="flex flex-col">
                <HeroBadge>
                  <Sparkles size={12} />
                  {isCreate ? 'New gallery' : 'Album editor'}
                </HeroBadge>
                <PageTitle className="linear-text">
                  {isCreate ? 'Create Album' : 'Update Album'}
                </PageTitle>
                <PageSubtitle>
                  {isCreate
                    ? 'Add cover photo, album details, and optional folders.'
                    : 'Edit cover, details, and folders for this album.'}
                </PageSubtitle>
              </div>
            </HeroText>
          </HeroLeft>
          {!isCreate && <HeroActionsSlot ref={heroActionsRef} />}
        </HeroRow>
      </Hero>

      <ScrollBody ref={scrollBodyRef}>
        {isCreate ? (
          <CreateNewAlbumPage />
        ) : (
          <EditAlbumPage heroActionsRef={heroActionsRef} />
        )}
      </ScrollBody>
    </PageContainer>
  )
}

export default SingleAlbum
